import React, { useState } from "react";
import { Options } from "../types/product";
import { WizardAction, WizardState } from "../types/WigWizard";
import hairColorMap from "../utils/hairColorMap";
import { Alert } from "./Popup";
import move from "../utils/reorderArray";

export function ProductOption({
  option,
  allOptions,
  index,
  dispatch,
  state,
}: {
  option: Options;
  allOptions: any;
  index: number;
  dispatch: React.Dispatch<WizardAction>;
  state: WizardState;
}): JSX.Element {
  const [showOptionPopup, setShowOptionPopup] = useState("");
  const optionsCopy = [
    "Explore our signature color options crafted by our licensed cosmetologists. Slight variations may occur.",
    "Length is measured by stretching the hair in its natural state. Note if you purchase wavy or very wavy texture, you may want to go up in length if you’re looking for a longer look.",
    "Frontals allow for more parting space and mimic a natural hairline from ear to ear. Closures are great for your go-to parting style and work well for people with lower hairlines. Beginner Wig Wearer? We recommend starting your new #wiglife journey with a closure wig!",
  ];

  function optionValueDisabled(option: Options, value: any): boolean {
    return option.values.indexOf(value) === -1;
  }

  function close() {
    document.body.scrollIntoView({ behavior: "smooth" });
    setShowOptionPopup("");
  }

  //remove options from adding new products
  allOptions[0] = allOptions[0].filter(
    (val) =>
      val === "Natural Black" ||
      val === "Auburn" ||
      val === "Jet Black" ||
      val === "Chocolate Brown" ||
      val === "Dark Ombre" ||
      val === "Caramel" ||
      val === "Rooted Chocolate Brown" ||
      val === "Blonde Balayage" ||
      val === "Platinum" ||
      val === "Light Rooted Blonde" ||
      val === "Dark Rooted Blonde" 
  );

  allOptions[1] = allOptions[1].filter(
    (val) =>
      val === `14"` ||
      val === `18"` ||
      val === `20"` ||
      val === `24"` ||
      val === `10"` 
  );
 
  allOptions[2] = allOptions[2].filter(
    (val) => val === `Closure` || val === `Frontal`
  );

  return (
    <div
      className="bg-white rounded-md lg:border lg:border-gray-300 pt-6 px-5 pb-8 mt-4"
      id={option.name}
    >
      <h3>{option.name === "Type" ? "Wig types" : option.name}</h3>
      <p className="text-product-m lg:text-product-d pt-2">
        {optionsCopy[index]}
      </p>
      <div
        className={
          option.name === "Type"
            ? "text-pill grid grid-cols-2 sm:grid-cols-4 mt-8 gap-y-4 gap-x-5 lg:gap-x-4"
            : option.name === "Color"
            ? "text-pill grid grid-cols-3 justify-start grow flex-wrap mt-8 gap-y-4 gap-x-5 lg:gap-x-4 lg:grid-cols-4"
            : "text-pill flex flex-row justify-start grow flex-wrap mt-8 gap-y-4 gap-x-5 lg:gap-x-4"
        }
      >
        {index === 1
          ? (state.Product == "kinky-curly" ||
            state.Product == "very-wavy" ||
            state.Product == "wavy"
              ? allOptions[index].slice(0, 4)
              : move(4, 0, allOptions[index])
            ).map((value: string) => {
              return value === '10"' ? (
                <span
                  className={
                    "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:sm:grow-0 text-center cursor-pointer relative inline-block"
                  }
                >
                  <label
                    onClick={() => {
                      optionValueDisabled(option, value)
                        ? setShowOptionPopup(value)
                        : null;
                    }}
                  >
                    <input
                      type="radio"
                      name={option.name}
                      disabled={optionValueDisabled(option, value)}
                      className="hidden peer"
                      onChange={() => {
                        dispatch({ type: option.name, value });
                        dispatch({ type: "Static" });
                      }}
                      checked={value === state[option.name]}
                    />
                    <div className="border border-black rounded-full py-2.5 px-2 peer-checked:bg-black peer-disabled:opacity-20 peer-checked:text-white">
                      {value}
                    </div>
                  </label>
                  <span className="absolute top-0 right-2 inline-flex items-center justify-center px-2 py-1 leading-nonetransform translate-x-1/2 -translate-y-1/2">
                    <img
                      className="h-10 w-26"
                      src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/new.png?v=1654621376"
                    ></img>
                  </span>
                </span>
              ) : (
                <label
                  className={
                    option.name !== "Type"
                      ? "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:sm:grow-0 text-center cursor-pointer relative"
                      : "text-center cursor-pointer relative"
                  }
                  onClick={() => {
                    optionValueDisabled(option, value)
                      ? setShowOptionPopup(value)
                      : null;
                  }}
                >
                  <input
                    type="radio"
                    name={option.name}
                    disabled={optionValueDisabled(option, value)}
                    className="hidden peer"
                    onChange={() => {
                      dispatch({ type: option.name, value });
                      dispatch({ type: "Static" });
                    }}
                    checked={value === state[option.name]}
                  />
                  <div className="border border-black rounded-full py-2.5 px-2 peer-checked:bg-black peer-disabled:opacity-20 peer-checked:text-white">
                    {value}
                  </div>
                </label>
              );
            })
          : index === 2 && state.Bang === "yes"
          ? allOptions[index].slice(0, 1).map((value: string) => {
              return (
                <label
                  className={
                    option.name !== "Type"
                      ? "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:sm:grow-0 text-center cursor-pointer relative"
                      : "text-center cursor-pointer relative"
                  }
                  onClick={() => {
                    optionValueDisabled(option, value)
                      ? setShowOptionPopup(value)
                      : null;
                  }}
                >
                  <input
                    type="radio"
                    name={option.name}
                    disabled={optionValueDisabled(option, value)}
                    className="hidden peer"
                    onChange={() => {
                      dispatch({ type: option.name, value });
                      dispatch({ type: "Static" });
                    }}
                    checked={value === state[option.name]}
                  />
                  {option.name === "Color" ? (
                    <>
                      <img
                        data-src={hairColorMap[value]}
                        className="lazyload ring-offset-2 ring-black rounded-full peer-checked:ring-1 peer-disabled:opacity-20 capitalize m-auto"
                      />

                      <p className="text-center capitalize mt-2">{value}</p>
                    </>
                  ) : (
                    <div className="border border-black rounded-full py-2.5 px-2 peer-checked:bg-black peer-disabled:opacity-20 peer-checked:text-white">
                      {value}
                    </div>
                  )}
                </label>
              );
            })
          : index === 0 && state.Product === "wavy"
          ? allOptions[index]
              .slice(0, 7)
              .filter((val) => val !== "Caramel" && val!=="Auburn")
              .map((value: string) => {
                return (
                  <label
                    className={
                      option.name !== "Type"
                        ? "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:sm:grow-0 text-center cursor-pointer relative"
                        : "text-center cursor-pointer relative"
                    }
                    onClick={() => {
                      optionValueDisabled(option, value)
                        ? setShowOptionPopup(value)
                        : null;
                    }}
                  >
                    <input
                      type="radio"
                      name={option.name}
                      disabled={optionValueDisabled(option, value)}
                      className="hidden peer"
                      onChange={() => {
                        dispatch({ type: option.name, value });
                        dispatch({ type: "Static" });
                      }}
                      checked={value === state[option.name]}
                    />
                    <img
                      data-src={hairColorMap[value]}
                      key={hairColorMap[value]}
                      className="lazyload ring-offset-2 ring-black rounded-full peer-checked:ring-1 peer-disabled:opacity-20 capitalize m-auto"
                    />

                    <span className={"relative inline-block"}>
                      <p className="text-center capitalize mt-2">{value}</p>
                      {value === "Rooted Chocolate Brown" ? (
                        <>
                          <span className="absolute bottom-9 left-8 inline-flex items-center justify-center px-2 py-1 leading-nonetransform translate-x-1/2 -translate-y-1/2">
                            <img
                              className="h-10 w-26"
                              src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/new.png?v=1654621376"
                            ></img>
                          </span>
                        </>
                      ) : null}
                    </span>
                  </label>
                );
              })
          : index === 0 && state.Product === "kinky-straight"
          ? allOptions[index]
              .slice(0, 7)
              .filter((val) => val !== "Caramel")
              .map((value: string) => {
                return (
                  <label
                    className={
                      option.name !== "Type"
                        ? "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:sm:grow-0 text-center cursor-pointer relative"
                        : "text-center cursor-pointer relative"
                    }
                    onClick={() => {
                      optionValueDisabled(option, value)
                        ? setShowOptionPopup(value)
                        : null;
                    }}
                  >
                    <input
                      type="radio"
                      name={option.name}
                      disabled={optionValueDisabled(option, value)}
                      className="hidden peer"
                      onChange={() => {
                        dispatch({ type: option.name, value });
                        dispatch({ type: "Static" });
                      }}
                      checked={value === state[option.name]}
                    />
                    <img
                      data-src={hairColorMap[value]}
                      key={hairColorMap[value]}
                      className="lazyload ring-offset-2 ring-black rounded-full peer-checked:ring-1 peer-disabled:opacity-20 capitalize m-auto"
                    />

                    <span className={"relative inline-block"}>
                      <p className="text-center capitalize mt-2">{value}</p>
                      {value === "Rooted Chocolate Brown" ? (
                        <>
                          <span className="absolute bottom-9 left-8 inline-flex items-center justify-center px-2 py-1 leading-nonetransform translate-x-1/2 -translate-y-1/2">
                            <img
                              className="h-10 w-26"
                              src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/new.png?v=1654621376"
                            ></img>
                          </span>
                        </>
                      ) : null}
                    </span>
                  </label>
                );
              })
          : index === 0 && state.Product === "very-straight"
          ? allOptions[index].slice(0, 8).map((value: string) => {
              return value === "Caramel" ||
                value === "Blonde Balayage" ||
                value === "Rooted Chocolate Brown" ? (
                <label
                  className={
                    option.name !== "Type"
                      ? "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:sm:grow-0 text-center cursor-pointer relative"
                      : "text-center cursor-pointer relative"
                  }
                  onClick={() => {
                    optionValueDisabled(option, value)
                      ? setShowOptionPopup(value)
                      : null;
                  }}
                >
                  <input
                    type="radio"
                    name={option.name}
                    disabled={optionValueDisabled(option, value)}
                    className="hidden peer"
                    onChange={() => {
                      dispatch({ type: option.name, value });
                      dispatch({ type: "Static" });
                    }}
                    checked={value === state[option.name]}
                  />
                  <>
                    <img
                      data-src={hairColorMap[value]}
                      key={hairColorMap[value]}
                      className="lazyload ring-offset-2 ring-black rounded-full peer-checked:ring-1 peer-disabled:opacity-20 capitalize m-auto"
                    />
                    <span className={"relative inline-block"}>
                      <p className="text-center capitalize mt-2">{value}</p>
                      {value === "Blonde Balayage" ? (
                        <span className="absolute bottom-6 left-8 inline-flex items-center justify-center px-2 py-1 leading-nonetransform translate-x-1/2 -translate-y-1/2">
                          <img
                            className="h-10 w-26"
                            src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/new.png?v=1654621376"
                          ></img>
                        </span>
                      ) : value === "Rooted Chocolate Brown" ? (
                        <span className="absolute bottom-9 left-8 inline-flex items-center justify-center px-2 py-1 leading-nonetransform translate-x-1/2 -translate-y-1/2">
                          <img
                            className="h-10 w-26"
                            src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/new.png?v=1654621376"
                          ></img>
                        </span>
                      ) : (
                        <span className="absolute bottom-6 right-0 inline-flex items-center justify-center px-2 py-1 leading-nonetransform translate-x-1/2 -translate-y-1/2">
                          <img
                            className="h-10 w-26"
                            src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/new.png?v=1654621376"
                          ></img>
                        </span>
                      )}
                    </span>
                  </>
                </label>
              ) : (
                <label
                  className={
                    option.name !== "Type"
                      ? "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:sm:grow-0 text-center cursor-pointer relative"
                      : "text-center cursor-pointer relative"
                  }
                  onClick={() => {
                    optionValueDisabled(option, value)
                      ? setShowOptionPopup(value)
                      : null;
                  }}
                >
                  <input
                    type="radio"
                    name={option.name}
                    disabled={optionValueDisabled(option, value)}
                    className="hidden peer"
                    onChange={() => {
                      dispatch({ type: option.name, value });
                      dispatch({ type: "Static" });
                    }}
                    checked={value === state[option.name]}
                  />

                  <>
                    <img
                      data-src={hairColorMap[value]}
                      key={hairColorMap[value]}
                      className="lazyload ring-offset-2 ring-black rounded-full peer-checked:ring-1 peer-disabled:opacity-20 capitalize m-auto"
                    />
                    <p className="text-center capitalize mt-2">{value}</p>
                  </>
                </label>
              );
            })
          : index === 0 && state.Product === "very-straight-blonde"
          ? allOptions[index].slice(8).map((value: string) => {
              return (
                <label
                  className={
                    option.name !== "Type"
                      ? "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:sm:grow-0 text-center cursor-pointer relative"
                      : "text-center cursor-pointer relative"
                  }
                  onClick={() => {
                    optionValueDisabled(option, value)
                      ? setShowOptionPopup(value)
                      : null;
                  }}
                >
                  <input
                    type="radio"
                    name={option.name}
                    disabled={optionValueDisabled(option, value)}
                    className="hidden peer"
                    onChange={() => {
                      dispatch({ type: option.name, value });
                      dispatch({ type: "Static" });
                    }}
                    checked={value === state[option.name]}
                  />
                  {option.name === "Color" ? (
                    <>
                      <img
                        data-src={hairColorMap[value]}
                        key={hairColorMap[value]}
                        className="lazyload ring-offset-2 ring-black rounded-full peer-checked:ring-1 peer-disabled:opacity-20 capitalize m-auto"
                      />
                      <p className="text-center capitalize mt-2">{value}</p>
                    </>
                  ) : (
                    <div className="border border-black rounded-full py-2.5 px-2 peer-checked:bg-black peer-disabled:opacity-20 peer-checked:text-white">
                      {value}
                    </div>
                  )}
                </label>
              );
            })
          : index === 0 && state.Product != "very-straight-blonde"
          ? allOptions[index].slice(0, 7).map((value: string) => {
              return value === "Caramel" ||
                value === "Rooted Chocolate Brown" ? (
                <label
                  className={
                    option.name !== "Type"
                      ? "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:sm:grow-0 text-center cursor-pointer relative"
                      : "text-center cursor-pointer relative"
                  }
                  onClick={() => {
                    optionValueDisabled(option, value)
                      ? setShowOptionPopup(value)
                      : null;
                  }}
                >
                  <input
                    type="radio"
                    name={option.name}
                    disabled={optionValueDisabled(option, value)}
                    className="hidden peer"
                    onChange={() => {
                      dispatch({ type: option.name, value });
                      dispatch({ type: "Static" });
                    }}
                    checked={value === state[option.name]}
                  />
                  <>
                    <img
                      data-src={hairColorMap[value]}
                      key={hairColorMap[value]}
                      className="lazyload ring-offset-2 ring-black rounded-full peer-checked:ring-1 peer-disabled:opacity-20 capitalize m-auto"
                    />
                    <span className={"relative inline-block"}>
                      <p className="text-center capitalize mt-2">{value}</p>
                      {value === "Rooted Chocolate Brown" ? (
                        <>
                          <span className="absolute bottom-9 left-8 inline-flex items-center justify-center px-2 py-1 leading-nonetransform translate-x-1/2 -translate-y-1/2">
                            <img
                              className="h-10 w-26"
                              src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/new.png?v=1654621376"
                            ></img>
                          </span>
                        </>
                      ) : (
                        <span className="absolute bottom-6 right-0 inline-flex items-center justify-center px-2 py-1 leading-nonetransform translate-x-1/2 -translate-y-1/2">
                          <img
                            className="h-10 w-26"
                            src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/new.png?v=1654621376"
                          ></img>
                        </span>
                      )}
                    </span>
                  </>
                </label>
              ) : (
                <label
                  className={
                    option.name !== "Type"
                      ? "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:sm:grow-0 text-center cursor-pointer relative"
                      : "text-center cursor-pointer relative"
                  }
                  onClick={() => {
                    optionValueDisabled(option, value)
                      ? setShowOptionPopup(value)
                      : null;
                  }}
                >
                  <input
                    type="radio"
                    name={option.name}
                    disabled={optionValueDisabled(option, value)}
                    className="hidden peer"
                    onChange={() => {
                      dispatch({ type: option.name, value });
                      dispatch({ type: "Static" });
                    }}
                    checked={value === state[option.name]}
                  />

                  <>
                    <img
                      data-src={hairColorMap[value]}
                      key={hairColorMap[value]}
                      className="lazyload ring-offset-2 ring-black rounded-full peer-checked:ring-1 peer-disabled:opacity-20 capitalize m-auto"
                    />
                    <p className="text-center capitalize mt-2">{value}</p>
                  </>
                </label>
              );
            })
          : allOptions[index].map((value: string) => {
              return (
                <label
                  className={
                    option.name !== "Type"
                      ? "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:sm:grow-0 text-center cursor-pointer relative"
                      : "text-center cursor-pointer relative"
                  }
                  onClick={() => {
                    optionValueDisabled(option, value)
                      ? setShowOptionPopup(value)
                      : null;
                  }}
                >
                  <input
                    type="radio"
                    name={option.name}
                    disabled={optionValueDisabled(option, value)}
                    className="hidden peer"
                    onChange={() => {
                      dispatch({ type: option.name, value });
                      dispatch({ type: "Static" });
                    }}
                    checked={value === state[option.name]}
                  />
                  <div className="border border-black rounded-full py-2.5 px-2 peer-checked:bg-black peer-disabled:opacity-20 peer-checked:text-white">
                    {value}
                  </div>
                </label>
              );
            })}
      </div>

      {option.name === "Type" ?<div className="text-product-m lg:text-product-d  mt-5 pl-2  inline-block ">
                         <img className="h-10 w-26 inline mr-3" src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/new.png?v=1654621376"/>
                         <span>Interested in our V-Part Wigs?      </span>
                         <a href="https://myparfait.com/pages/v-part-wigs" className="underline ">Shop Here</a>
                          </div>: null}

      {showOptionPopup && (
        <Alert
          message={""}
          messageContext={`The color option you selected "${showOptionPopup}" is not currently available in a "${state.Product.replaceAll(
            "-",
            " "
          )}" texture.
      Click "OK" below to change the texture.`}
          buttonText="Ok"
          buttonAction={close}
        />
      )}
    </div>
  );
}
